module.exports = __webpack_public_path__ + "static/media/kneenetic-2.0999cde7.jpg";